var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDragThumbIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 4,
  height: 25
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 25,
  rx: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2,
  cy: 19.231,
  fill: "#707070",
  rx: 2,
  ry: 1.923
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2,
  cy: 12.5,
  fill: "#707070",
  rx: 2,
  ry: 1.923
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2,
  cy: 5.769,
  fill: "#707070",
  rx: 2,
  ry: 1.923
}))));
export default SvgDragThumbIcon;